/** @format */

import { useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';
import ClubStatusBadge from './ClubStatusBadge';

const MyClubs = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [clubs, setClubs] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    fetchClubs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const fetchClubs = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/club/my${search}`,
      {},
      (res) => {
        setClubs(res.data.data ?? []);
        setMeta(res.data.meta ?? null);
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('دریافت باشگاه‌ها با خطا مواجه شد');
      },
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Master>
      <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-3 my-3'>
        <div className='d-flex flex-row align-items-center'>
          <i className='fad fa-shield-alt f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-14 font-weight-bold mb-0'>
            باشگاه‌های من
          </h1>
        </div>
        <Link to='/panel/clubs/create' className='btn btn-info btn-sm f-13'>
          <i className='fad fa-plus ms-1'></i>
          ثبت باشگاه جدید
        </Link>
      </div>

      {clubs.length === 0 ? (
        <div className='card border shadow-sm'>
          <div className='card-body text-center py-5'>
            <i className='fad fa-shield-alt f-40 text-muted mb-3 d-block'></i>
            <p className='text-muted f-14 mb-3'>
              هنوز باشگاهی ثبت نکرده‌اید.
            </p>
            <Link to='/panel/clubs/create' className='btn btn-info btn-sm'>
              ثبت اولین باشگاه
            </Link>
          </div>
        </div>
      ) : (
        <div className='row g-3'>
          {clubs.map((club) => (
            <div key={club.id} className='col-lg-6'>
              <div className='card border shadow-sm h-100'>
                {club.images?.[0]?.url && (
                  <div
                    className='card-img-top bg-light'
                    style={{ height: 180, overflow: 'hidden' }}
                  >
                    <img
                      src={club.images[0].url}
                      alt={club.title}
                      className='w-100 h-100 object-fit-cover'
                    />
                  </div>
                )}
                <div className='card-body'>
                  <div className='d-flex justify-content-between align-items-start mb-2'>
                    <h2 className='f-15 font-weight-bold mb-0'>{club.title}</h2>
                    <ClubStatusBadge
                      status={club.status}
                      label={club.status_label}
                    />
                  </div>

                  <div className='text-muted f-12 mb-2'>
                    <div>
                      <i className='fad fa-map-marker-alt ms-1'></i>
                      {club.province_name} — {club.city_name}
                    </div>
                    <div className='mt-1'>
                      <i className='fad fa-phone ms-1'></i>
                      {club.phone}
                    </div>
                    <div className='mt-1'>
                      <i className='fad fa-user-tie ms-1'></i>
                      مربی: {club.coach?.full_name || '—'}
                    </div>
                  </div>

                  {club.status === 2 && club.reject_reason && (
                    <div className='alert alert-danger f-12 py-2 mb-2'>
                      <strong>دلیل رد:</strong> {club.reject_reason}
                    </div>
                  )}

                  <div className='d-flex flex-wrap gap-2 mt-3'>
                    {(club.status === 0 || club.status === 2) && (
                      <Link
                        to={`/panel/clubs/edit/${club.id}`}
                        className='btn btn-outline-primary btn-sm f-12'
                      >
                        ویرایش
                      </Link>
                    )}
                    <span className='badge bg-light text-dark border f-12 py-2'>
                      {club.images?.length || 0} تصویر
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {meta?.pagination?.total_pages > 1 && (
        <Pagination
          totalPage={meta.pagination.total_pages}
          basePath='/panel/clubs/my'
        />
      )}
    </Master>
  );
};

export default MyClubs;
